module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": _vm.option.id,
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog choose-modal"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title text-left"
  }, [_vm._v(_vm._s(_vm.option.title) + "\n          "), _c('div', {
    staticClass: "input-group pull-right m-r-15",
    staticStyle: {
      "width": "200px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchLabel),
      expression: "searchLabel"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchLabel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchLabel = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body text-left"
  }, [_c('div', {
    staticClass: "text-left"
  }, [_vm._l((_vm.filteredList), function(elem) {
    return (_vm.curId !== elem.item_id) ? _c('button', {
      staticClass: "btn btn-default btn-choose-element",
      class: {
        active: elem.active
      },
      on: {
        "click": function($event) {
          return _vm.clickElement(elem)
        },
        "mouseover": function($event) {
          return _vm.showRemark(elem)
        },
        "mouseleave": function($event) {
          return _vm.hideRemark()
        }
      }
    }, [_vm._v("\n            " + _vm._s(elem.name)), (_vm.showMoney) ? _c('span', [_vm._v("  $" + _vm._s(_vm.getPrice(elem.price)))]) : _vm._e(), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "text-remark-wrap"
    }, [_c('small', [_vm._v(" " + _vm._s(elem.remark) + " ")])])]) : _vm._e()
  }), _vm._v(" "), (!_vm.elementList.length) ? _c('p', {
    staticClass: "text-danger text-center"
  }, [_vm._v("無法" + _vm._s(_vm.option.title))]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.clearAll
    }
  }, [_vm._v("全取消")]), _vm._v(" "), (!_vm.hideCancel) ? _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_vm._v("取消")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.trigger(_vm.option.event)
      }
    }
  }, [_vm._v("\n          確定\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0982022a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/ChooseModal.vue
// module id = 2309
// module chunks = 1